import SearchResults from './styled';

export default SearchResults;
